// In non-local environments, public-router routes /api/ to the Mononoth APIs. To avoid this clash,
// public-router routes /productlistings-api/ to browse-productlistings, which then rewrites the path
// back to its own /api/ path (see publicApiRewrites + next.config.ts).
export const PUBLIC_API_BASE_PATH = '/productlistings-api/';

// Defined here (rather than inline in next.config.ts) so it can be unit-tested without importing
// next.config.ts, which runs envalid.cleanEnv at import time and would fail without full env vars.
export const publicApiRewrites = () => [
  { source: `${PUBLIC_API_BASE_PATH}:path*`, destination: '/api/:path*' },
];
